import PopupWrapper from "../components/PopupWrapper";
import ProductManageForm from "../components/ProductManageForm";
import { setGlobalProductPopupElement } from "../features/popupSlice";
import { getImageArray, getImageUrl, jsonParseSafe } from "../utils";

export const addProductComponents = (editor, dispatch) => {
	// Register the Product Card component
	editor.BlockManager.add("product-card", {
		label: "Product Card",
		category: "Custom Widgets",
		attributes: { class: "fa fa-id-card" },
		content: `
      <div class="product-card" style="max-width:200px; text-align:center" data-gjs-type="product-card">
        <img src="https://via.placeholder.com/150" alt="Product Image" style="width: 200px; height:200px; border-radius: 4px;" />
        <h3 style="font-size: 18px; color: #333; margin: 10px 0;">Product Title</h3>
        <p style="font-size: 14px; color: #555; margin: 0 0 10px;">$19.99</p>
      </div>
    `,
	});

	// Register 'product-card' component type to ensure it displays correctly within 'product-list'
	editor.DomComponents.addType("product-card", {
		model: {
			defaults: {
				tagName: "div",
				draggable: true,
				droppable: true,
			},
		},
	});

	editor.BlockManager.add("product-list", {
		label: "Product List",
		category: "Custom Widgets",
		attributes: { class: "fa fa-th" },
		content: {
			type: "product-list",
			components: Array.from({ length: 6 }).map(() => ({
				type: "custom-product-card",
				attributes: {
					class: "custom-product-card",
				},
			})),
			style: {
				display: "grid",
				gap: "10px",
				"grid-template-columns": "repeat(6, 1fr)",
				"max-width": "100%",
			},
			traits: [
				{
					type: "button",
					text: "Add Product",
					full: true,
					command: "add-product-card",
				},
			],
		},
	});

	editor.Commands.add("add-product-card", {
		run(editor) {
			console.log("Button clicked", {
				editor,
			});

			let logical;
			let custom;

			const selectedComponent = editor.getSelected();
			if (selectedComponent) {
				const customData = jsonParseSafe(
					selectedComponent.getAttributes()["data-custom"]
				);

				logical = customData?.logical;
				custom = customData?.custom;
			}

			// Dispatch an action to update the store
			dispatch?.(
				setGlobalProductPopupElement(
					<PopupWrapper
						onClose={() => {
							dispatch?.(setGlobalProductPopupElement(null));
						}}>
						<ProductManageForm
							title="Manage Left Slider Products"
							logical={logical}
							custom={custom}
							onUpdate={(logical, custom) => {
								// setProducts({
								// 	logical:
								// 		logical || undefined,
								// 	custom: custom || [],
								// });

								if (custom?.length) {
									const products = custom || [];

									// Find the column container and add a new product card component with the data
									const columnContainer =
										editor.getSelected();
									if (
										columnContainer &&
										columnContainer.is("column-container")
									) {
										// remove existing product card
										columnContainer
											.components()
											.forEach((component) => {
												component.remove();
											});

										products.forEach((product) => {
											// add new product card
											columnContainer.append({
												type: "custom-product-card-v1",
												attributes: {
													class: "custom-product-card-v1",
												},
												style: {
													"max-width": "232px",
													"text-align": "center",
													border: "1px solid #ddd",
													padding: "10px",
													"border-radius": "4px",
												},
												components: [
													{
														type: "image",
														attributes: {
															src: getImageUrl(
																getImageArray(
																	product.thumbnail
																)[0]
															),
															alt: "Product Image",
														},
														editable: false,
														droppable: false,
														draggable: false,
														style: {
															width: "200px",
															height: "200px",
															"border-radius":
																"4px",
															"object-fit":
																"contain",
														},
													},
													{
														type: "text",
														content: product.name,
														editable: false,
														droppable: false,
														draggable: false,
														style: {
															"font-size": "18px",
															color: "#333",
															margin: "10px 0",
														},
													},
													{
														type: "text",
														content:
															product.discountedPrice,
														editable: false,
														droppable: false,
														draggable: false,
														style: {
															"font-size": "14px",
															color: "#555",
															margin: "0 0 10px",
														},
													},
												],
											});
										});
									}
								}

								const selectedComponent = editor.getSelected();
								if (selectedComponent) {
									selectedComponent.setAttributes({
										"data-custom": JSON.stringify({
											logical,
											custom,
										}),
									});
								}

								dispatch?.(setGlobalProductPopupElement(null));
							}}
						/>
					</PopupWrapper>
				)
			);

			// Example data for a new product; replace this with dynamic input as needed
			const newProduct = {
				title: "New Product",
				imageUrl: "https://via.placeholder.com/150",
				price: "$29.99",
			};
		},
	});

	editor.BlockManager.add("product-card-row", {
		label: "Product Card Row",
		category: "Custom Widgets",
		attributes: { class: "fa fa-id-list" },
		content: {
			tagName: "div",
			attributes: { class: "product-card-row" },
			style: {
				display: "flex",
				justifyContent: "space-between",
				padding: "10px",
				border: "1px solid #ddd",
				borderRadius: "8px",
				boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
				backgroundColor: "#ffffff",
			},
			components: [
				{
					tagName: "div",
					type: "product-card",
					attributes: { class: "product-card" },
				},
				{
					tagName: "div",
					type: "product-card",
					attributes: { class: "product-card" },
				},
				{
					tagName: "div",
					type: "product-card",
					attributes: { class: "product-card" },
				},
			],
		},
	});

	// Register the "Card" component block
	editor.BlockManager.add("custom-card", {
		label: "Card",
		category: "Custom Components",
		attributes: { class: "fa fa-id-card" },
		content: {
			tagName: "div",
			attributes: { class: "card-component" },
			style: {
				width: "300px",
				padding: "10px",
				border: "1px solid #ddd",
				borderRadius: "8px",
				boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
				backgroundColor: "#ffffff",
			},
			components: [
				// Card header (title)
				{
					tagName: "h3",
					type: "text",
					content: "Card Title",
					style: {
						textAlign: "center",
						fontWeight: "bold",
						color: "#333",
					},
				},
				// Card image
				{
					tagName: "img",
					type: "image",
					attributes: {
						src: "https://via.placeholder.com/300x150",
						alt: "Card Image",
					},
					style: {
						width: "100%",
						borderRadius: "4px",
						marginTop: "10px",
					},
				},
				// Card description (paragraph text)
				{
					tagName: "p",
					type: "text",
					disable: true,
					editable: false,
					content:
						"This is a sample description for the card component.",
					style: {
						fontSize: "14px",
						color: "#555",
						textAlign: "center",
						marginTop: "10px",
						lineHeight: "1.5",
					},
				},
				// Card button
				{
					tagName: "button",
					type: "text",
					content: "Learn More",
					attributes: { class: "card-button" },
					style: {
						display: "block",
						margin: "10px auto 0",
						padding: "10px 20px",
						fontSize: "14px",
						color: "#ffffff",
						backgroundColor: "#007bff",
						border: "none",
						borderRadius: "4px",
						cursor: "pointer",
					},
				},
				{
					type: "product-card",
					attributes: {
						class: "product-card",
					},
				},
				{
					type: "custom-products-slider",
					attributes: {
						class: "custom-products-slider",
					},
				},
			],
		},
	});

	// Add custom CSS for card button hover effect (optional)
	editor.CssComposer.addRules(
		".card-button:hover { background-color: #0056b3 }"
	);

	// Add general CSS styling for the card component if needed
	editor.CssComposer.addRules(".card-component { box-sizing: border-box");
};

export const addCustomComponents = (editor) => {
	// Register the "Container" block
	editor.BlockManager.add("container-block", {
		label: "Container",
		category: "Basic",
		attributes: { class: "fa fa-square" }, // Use any icon here
		content: {
			tagName: "div",
			draggable: true,
			droppable: true,
			attributes: { class: "container-widget container" },
		},
	});

	editor.BlockManager.add("custom-column", {
		label: "Column",
		category: "Layout",
		attributes: { class: "fa fa-columns" },
		content: {
			type: "custom-column",
			style: {
				width: "100%", // default to full width
				padding: "10px",
				border: "1px solid #ddd",
			},
			components: [
				{
					type: "text",
					content: "Column content",
				},
			],
			traits: [
				{
					type: "range",
					label: "Width (%)",
					name: "width",
					min: 10,
					max: 100,
					step: 10,
					changeProp: true,
				},
			],
		},
	});

	editor.DomComponents.addType("custom-column", {
		model: {
			defaults: {
				tagName: "div",
				droppable: true,
				resizable: {
					// Configure resizable handles
					cr: 1, // Right handle
					cl: 1, // Left handle
				},
				// Listen for width changes
				script() {
					this.on("change:width", this.updateWidth);
				},
			},

			init() {
				// Handle trait change for width
				this.on("change:width", this.updateWidth);
			},

			updateWidth() {
				const width = this.get("width") || 100;
				this.addStyle({ width: `${width}%` });
			},
		},

		view: {
			onRender() {
				const width = this.model.get("width") || 100;
				this.el.style.width = `${width}%`;
			},
		},
	});

	editor.DomComponents.addType("custom-column", {
		model: {
			defaults: {
				tagName: "div",
				droppable: true,
				resizable: true,
				style: {
					padding: "10px",
					border: "1px solid #ddd",
				},
				components: [
					{
						type: "text",
						content: "Column content",
					},
				],
			},
		},
	});

	editor.BlockManager.add("column-container", {
		label: "Column Container",
		category: "Layout",
		attributes: { class: "fa fa-th-large" },
		content: {
			type: "column-container",
			style: {
				display: "grid",
				gap: "10px",
				"grid-template-columns": "repeat(6, 1fr)", // default to 6 columns
				"max-width": "100%",
			},
			components: Array.from({ length: 1 }).map(() => ({
				type: "custom-product-card",
				attributes: {
					class: "custom-product-card",
				},
			})),
			traits: [
				{
					type: "select",
					label: "Columns",
					name: "columns",
					options: [
						{ value: "1", name: "1", id: "1" },
						{ value: "2", name: "2", id: "2" },
						{ value: "3", name: "3", id: "3" },
						{ value: "4", name: "4", id: "4" },
						{ value: "5", name: "5", id: "5" },
						{ value: "6", name: "6", id: "6" },
					],
					changeProp: true,
				},
				{
					type: "button",
					text: "Add Product",
					full: true,
					command: "add-product-card",
				},
			],
		},
	});

	editor.DomComponents.addType("column-container", {
		model: {
			defaults: {
				tagName: "div",
				droppable: true,
				resizable: true,
				// Default column count
				columns: 6,
			},

			init() {
				// Listen for trait changes
				this.on("change:columns", this.updateColumns);
			},

			updateColumns() {
				const cols = this.get("columns") || 6;
				this.addStyle({
					"grid-template-columns": `repeat(${cols}, 1fr)`,
				});
			},
		},

		view: {
			onRender() {
				// Apply the initial column setup
				const cols = this.model.get("columns") || 6;
				this.el.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;
			},
		},
	});

	editor.BlockManager.add("custom-button", {
		label: "Custom Button",
		category: "Custom Widgets",
		attributes: { class: "fa fa-hand-pointer" },
		content: {
			type: "custom-button",
			content: "Custom Button",
			style: {
				padding: "10px 20px",
				color: "#fff",
				background: "#007bff",
				"border-radius": "5px",
				cursor: "pointer",
				"text-align": "center",
			},
			traits: [
				{
					type: "select",
					label: "Action",
					name: "actionType",
					options: [
						{ value: "addToCart", name: "Add to Cart" },
						{ value: "goToCheckout", name: "Go to Checkout" },
						{ value: "goToLogin", name: "Go to Login" },
						{ value: "buyNow", name: "Buy Now" },
					],
					changeProp: true,
				},
				{
					type: "text",
					label: "Product ID",
					name: "productId",
					placeholder: "Enter Product ID (optional)",
				},
			],
		},
	});

	editor.DomComponents.addType("custom-button", {
		model: {
			defaults: {
				tagName: "button",
				droppable: false,
				draggable: true,
				actionType: "addToCart", // Default action
				productId: "", // Default product ID
				traits: [
					{
						type: "select",
						label: "Action",
						name: "actionType",
						options: [
							{ value: "addToCart", name: "Add to Cart" },
							{ value: "goToCheckout", name: "Go to Checkout" },
							{ value: "goToLogin", name: "Go to Login" },
							{ value: "buyNow", name: "Buy Now" },
						],
						changeProp: true,
					},
					{
						type: "text",
						label: "Product ID",
						name: "productId",
						placeholder: "Enter Product ID (optional)",
					},
				],
				script: function () {
					// Add the click event to the button
					this.addEventListener("click", () => {
						const actionType = "{[ actionType ]}";
						const productId = "{[ productId ]}";

						switch (actionType) {
							case "addToCart":
								console.log("Add to Cart", productId);
								// Trigger your frontend "Add to Cart" logic here
								break;
							case "goToCheckout":
								console.log("Go to Checkout");
								window.location.href = "/checkout"; // Example navigation
								break;
							case "goToLogin":
								console.log("Go to Login");
								window.location.href = "/login"; // Example navigation
								break;
							case "buyNow":
								console.log("Buy Now", productId);
								// Trigger your frontend "Buy Now" logic here
								break;
							default:
								console.warn("No action defined");
						}
					});
				},
			},
		},
	});
};

export const addCustomBuilderLayout = (editor) => {
	editor.BlockManager.add("row", {
		label: "Row",
		category: "Layout",
		attributes: { class: "fa fa-columns" },
		content: {
			type: "row",
			style: {
				display: "flex",
				"flex-wrap": "wrap",
				"justify-content": "center",
				"align-items": "center",
			},
			components: [
				{
					type: "column",
					style: {
						"flex-basis": "33.33%",
						padding: "10px",
					},
					components: [],
				},
			],
		},
	});

	editor.DomComponents.addType("row", {
		model: {
			defaults: {
				traits: [
					{
						type: "select",
						label: "Justify Content",
						name: "justify-content",
						options: [
							{ value: "center", name: "Center" },
							{ value: "flex-start", name: "Start" },
							{ value: "flex-end", name: "End" },
							{ value: "space-between", name: "Space Between" },
							{ value: "space-around", name: "Space Around" },
						],
						changeProp: true,
					},
				],
			},
			init() {
				this.on("change:justify-content", this.updateJustifyContent);
			},
			updateJustifyContent() {
				const justifyContent = this.get("justify-content") || "center";
				this.addStyle({ "justify-content": justifyContent });
			},
		},
	});

	editor.DomComponents.addType("column", {
		model: {
			defaults: {
				traits: [
					{
						type: "number",
						label: "Width (%)",
						name: "width",
						changeProp: true,
					},
					{
						type: "number",
						label: "Padding (px)",
						name: "padding",
						changeProp: true,
					},
				],
			},
			init() {
				this.on("change:width change:padding", this.updateStyle);
			},
			updateStyle() {
				const width = this.get("width") || 33.33;
				const padding = this.get("padding") || 10;
				this.addStyle({
					"flex-basis": `${width}%`,
					padding: `${padding}px`,
				});
			},
		},
	});

	editor.TraitManager.addType("number", {
		extend: "input",
		createInput({ trait }) {
			const input = document.createElement("input");
			input.type = "number";
			input.min = trait.attributes.min || 0;
			input.max = trait.attributes.max || 100;
			return input;
		},
	});

	editor.Panels.addPanel({
		id: "settings-panel",
		el: ".settings-panel",
		buttons: [
			{
				id: "open-traits",
				className: "fa fa-cog",
				command: "open-traits",
				attributes: { title: "Settings" },
			},
		],
	});

	editor.BlockManager.add("2-column-layout", {
		label: "2 Column Layout",
		category: "Layout",
		attributes: { class: "fa fa-columns" },
		content: {
			type: "row",
			components: [
				{
					type: "column",
					style: {
						"flex-basis": "50%",
						padding: "10px",
					},
				},
				{
					type: "column",
					style: {
						"flex-basis": "50%",
						padding: "10px",
					},
				},
			],
		},
	});

	editor.StyleManager.addSector("layout", {
		name: "Layout",
		open: true,
		buildProps: [
			"display",
			"flex-direction",
			"justify-content",
			"align-items",
			"flex-wrap",
			"gap",
		],
	});

	editor.StyleManager.addSector("spacing", {
		name: "Spacing",
		open: false,
		buildProps: ["margin", "padding"],
	});
};

export const panelCustomizer = (editor) => {
	editor.Panels.getPanel("options")
		.get("buttons")
		.add([
			{
				id: "preview",
				className: "fa fa-eye",
				command: "preview",
				attributes: { title: "Preview" },
			},
			{
				id: "export",
				className: "fa fa-code",
				command: "export-template",
				attributes: { title: "Export" },
			},
		]);

	// Add a custom panel
	editor.Panels.addPanel({
		id: "custom-panel",
		el: ".custom-panel", // Add a custom HTML container
		buttons: [
			{
				id: "custom-button",
				className: "fa fa-star",
				command: () => alert("Custom action triggered!"),
				attributes: { title: "Custom Button" },
			},
		],
	});

	editor.StyleManager.addSector("custom-sector", {
		name: "Custom Sector",
		open: true,
		buildProps: ["background-color", "border-radius", "box-shadow"],
		properties: [
			{
				property: "background-color",
				type: "color",
			},
			{
				property: "border-radius",
				type: "slider",
				defaults: 0,
				step: 1,
				max: 50,
			},
		],
	});

	editor.Panels.getPanel("devices-c")
		.get("buttons")
		.add({
			id: "custom-device",
			command: () => editor.setDevice("Custom Device"),
			className: "fa fa-mobile",
			attributes: { title: "Custom Device" },
		});

	const customCSS = `
  .gjs-block-label {
    font-size: 14px !important;
    font-weight: bold !important;
    color: #4CAF50 !important;
  }

  .gjs-toolbar {
    background: #333 !important;
  }

  .gjs-pn-commands {
    background-color: #222 !important;
  }
`;

	const style = document.createElement("style");
	style.innerHTML = customCSS;
	document.head.appendChild(style);

	editor.BlockManager.add("custom-block", {
		label: `<div style="padding: 5px; text-align: center;">
              <i class="fa fa-cog" style="font-size: 24px;"></i>
              <div>Custom Block</div>
            </div>`,
		category: "Custom Blocks",
		content: "<div>Custom Content</div>",
	});

	editor.DomComponents.addType("custom-component", {
		model: {
			defaults: {
				toolbar: [
					{
						attributes: { class: "fa fa-arrows" },
						command: "tlb-move", // Move command
					},
					{
						attributes: { class: "fa fa-clone" },
						command: "tlb-clone", // Clone command
					},
					{
						attributes: { class: "fa fa-trash" },
						command: "tlb-delete", // Delete command
					},
				],
			},
		},
	});

	editor.DeviceManager.add("Custom Device", {
		width: "1280px", // Custom width
		height: "800px", // Optional height
	});

	editor.Modal.open({
		title: "Custom Modal",
		content: "<div>Custom Modal Content</div>",
	});
};
